import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'

// amplify
import { Auth } from 'aws-amplify'

import { push } from 'connected-react-router'

interface Breadcrumb {
    name: string,
    path: string
}

interface BreadcrumbsState {
    data: Breadcrumb[] | null | undefined,
}

const initialState: BreadcrumbsState = {
    data: null,
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearBreadcrumbs: (state) => {
            state.data = null
        },
        setBreadcrumbs: (state, action: PayloadAction<Breadcrumb[]>) => {
            state.data = action.payload
        }
    },
})

export const { clearBreadcrumbs, setBreadcrumbs } = userSlice.actions
export default userSlice.reducer